import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SaveService } from '../shared/services/save.service';
import { Institution } from '../shared/model/institution';
import { InstitutionsService } from '../shared/services/institutions.service';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-responsible-dashboard',
  templateUrl: './responsible-dashboard.component.html',
  styleUrls: ['./responsible-dashboard.component.css']
})
export class ResponsibleDashboardComponent implements OnInit {

  constructor(private router: Router,
    private saveService: SaveService,
    public snackBar: MatSnackBar,
    private institutionsService: InstitutionsService) { }

  userInstitution: Institution[] = [];
  nbfavorite: number;

  ngOnInit() {
    this.saveService.setTitle("Console")
    if (this.saveService.getUser()) {
      this.getFavoriteUser();
    }
  }

  getFavoriteUser() {
    this.saveService.getUser().favoriteInstitution
      .map((id, index) => {
        this.nbfavorite = index;
        if (index !== 0) {
          this.institutionsService.findInstitutionById(id.institution)
            .subscribe(institution => this.userInstitution.push(institution))
        }
      });
  }

  toggle(type: string, institution: Institution) {
    if (type === "student") {
      institution.student = !institution.student
      this.institutionsService.saveInstitution(institution.$key, institution).subscribe(
        () => {
          var mess: string;
          console.info(`Student toogle ${institution.student} for institution ${institution.institutionName} (${institution.$key})`)
          if (institution.student) {
            mess = `L'école "${institution.institutionName}" est fermée pour les étudiants`
          } else {
            mess = `L'école "${institution.institutionName}" est ouverte pour les étudiants`
          }
          this.openSnackBar(mess,`N'oubliez pas d'approuver les modifications`),
          err => console.error(`Error toogling student for instiution ${institution.$key} Error = ${err}`)
        })
    } else if (type === "teacher") {
      institution.teacher = !institution.teacher
      this.institutionsService.saveInstitution(institution.$key, institution).subscribe(
        () => {
          var mess: string;
          console.info(`Teacher toogle ${institution.teacher} for institution ${institution.institutionName} (${institution.$key})`)
          if (institution.teacher) {
            mess = `L'école "${institution.institutionName}" est fermée pour les professeurs`
          } else {
            mess = `L'école "${institution.institutionName}" est ouverte pour les professeurs`
          }
          this.openSnackBar(mess,`N'oubliez pas d'approuver les modifications`),
          err => console.error(`Error toogling teacher for instiution ${institution.$key} Error = ${err}`)
        })
    } else if (type === "buses") {
      institution.buses = !institution.buses
      this.institutionsService.saveInstitution(institution.$key, institution).subscribe(
        () => {
          var mess: string;
          console.info(`Buses toogle ${institution.buses} for institution ${institution.institutionName} (${institution.$key})`)
          if (institution.buses) {
            mess = `Le transport scolaire pour l'école "${institution.institutionName}" est fermé`
          } else {
            mess = `Le transport scolaire pour l'école "${institution.institutionName}" est ouvert`
          }    
          this.openSnackBar(mess,`N'oubliez pas d'approuver les modifications`),      
          err => console.error(`Error toogling buses for instiution ${institution.$key} Error = ${err}`)
        })
    } else if (type === "guardDuty") {
      institution.guardDuty = !institution.guardDuty
      this.institutionsService.saveInstitution(institution.$key, institution).subscribe(
        () => {
          var mess: string;
          console.info(`GuardDuty toogle to ${institution.guardDuty} for institution ${institution.institutionName} (${institution.$key})`)
          if (institution.guardDuty) {
            mess = `Le service de garde pour l'école "${institution.institutionName}" est fermé`
          } else {
            mess = `Le service de garde pour l'école "${institution.institutionName}" est ouvert`
          }
          this.openSnackBar(mess,`N'oubliez pas d'approuver les modifications`),  
          err => console.error(`Error toogling guardDuty for instiution ${institution.$key} Error = ${err}`)
        })
    }
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 8000,
    });
  }

  mesOptions() {
    console.log("goto choice-responsible")
    this.router.navigate(['choice-responsible'])
  }

}



// WEBPACK FOOTER //
// C:/dev/Perso/urmeo/src/app/responsible-dashboard/responsible-dashboard.component.ts